'use strict';
import React from "react";
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment, {now} from 'moment';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import "react-big-calendar/lib/css/react-big-calendar.css";
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss';
import 'components/Parts/CalendarParts/css/custom-calendar.scss';
import {Parts, Types, Objects, Collections} from "components/index";
import API from "@beardeddevops/react.api";
import {confirmAlert} from "react-confirm-alert";
import CalendarToolbarFE from "./CalendarToolBarFE";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TextField from "@material-ui/core/TextField";
import {Link} from "react-router-dom";
import Tab from "@material-ui/core/Tab";
import UserRoles from "../../../constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import classNames from "classnames";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";

//ALl view array for big calendar
// let allViews = Object.keys(Views).map(k => Views[k]);

export default class EngineerCalendar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			ticket: this.props.ticket,
			events: {...this.props.events},
			resourceMap: this.props.resourceMap,
			displayDragItemInCell: true,
			currentEvent: {id: null, title: null, start: null, end: null, resourceId: null, ticket: " ", allDay: false},
		};
		this.state.events = [];
		this.state.mapsUrls = [];
		this.state.week = moment().format('w') - moment().startOf('month').format('w')
		this.state.tab = 'simple'

		this.modDate();
	}

	componentDidUpdate(prevState, prevProps, snapshot) {
		if (this.props.mapsUrls !== this.state.mapsUrls) {
			this.setState({mapsUrls: this.props.mapsUrls})
		}
	}

	handleTabChange = (event, newValue) => {
		this.props.history.push('#' + newValue);
		this.setState({tab: newValue});
	};

	handleDragStart = event => {
		// console.log("handDragStart");
		this.setState({draggedEvent: event});
	}

	handleSelect = async ({start, end, resourceId}) => {
		const event = {start: start, end: end, resourceId: resourceId, ticket: this.state.ticket}
		this.toggle(event)

	}

	modDate = (events = null) => {
		//TODO: can make this faster, eventually, by making sure this is only called once. It gets called a few times
		let spreaded = events == null ? this.props.events : events;
		spreaded.forEach(e => {
			e.start = new Date(e.start);
			e.end = new Date(e.end);
		})
		this.state.events = spreaded;
	}

	toggle = (event) => {
		if (event.ticket === undefined || event.ticket === null || event.ticket === this.props.ticket) {
			this.setState({showModal: true, currentEvent: event});
		} else {
			this.setState({showTicketModal: true, currentEvent: event});
		}
	}

	toggleModalCalendarLog = () => {
		this.setState({
			modalCalendarLog: true
		})
	}

	toggleClose = () => {
		this.setState({
			showModal: false,
			showTicketModal: false
		})
	}

	toggleCloseCalendarLog = () => {
		this.setState({
			modalCalendarLog: false
		})
	}

	handleNavigate = (date) => {
		this.props.handleDate(date)
		let week = moment(date).format('w') - moment(date).startOf('month').format('w')
		if (this.state.week !== week) {
			this.setState({week: week});
			//call refresh data here and pass the date
			//TODO: this is making the tickets not show up, so might just need to handle it differently if navigating within the same week
			this.props.updateData();
		} else {
			this.props.updateCalResources();
		}
	}

	handleCurrentEventDate = (name, date) => {
		let {currentEvent} = this.state
		currentEvent[name] = date
		this.setState({currentEvent: currentEvent})
	}

	handleView = (view) => {
		this.setState({currentView: view})
	}

	eventStyleGetter = (event) => {
		const style = {
			backgroundColor: event.color ? event.color : event.users.eventColor,
		};
		return {
			style: style
		};
	}


	render() {
		const calendarID = this.state.currentEvent.id;
		const today = new Date();
		const currentEvent = this.state.currentEvent
		if (currentEvent.start?.toString().includes("00:00:00") && currentEvent.end?.toString().includes("00:00:00")) {
			currentEvent.allDay = true
		}
		this.modDate();
		const formats = {
			eventTimeRangeFormat: () => {
				return "";
			},
			timeGutterFormat: 'h A'
		};
		return (
			<div>
				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>
					<Tab label="Simplified View" value="simple"/>
					<Tab label="Calendar View" value="calendar"/>
				</Tabs>
				<div className={classNames({'hidden': this.state.tab !== 'calendar'})}>
					<div className={"row"}>
						<div className={"col-md-12"}>
							<Calendar
								onNavigate={(date) => this.handleNavigate(date)}
								localizer={momentLocalizer(moment)}
								events={this.state.events}
								components={{
									toolbar: props => (<CalendarToolbarFE {...props} handleView={(view) => this.handleView(view)} dailyLink={this.state.currentView === 'week' ? 'https://www.google.com/maps/dir' : this.state.mapsUrls}/>),
									event: Parts.Event,
									resourceHeader: (obj) => {
										return (<div style={{display: 'flex', flexDirection: 'column'}}>
											{this.state.currentView !== 'week' && <>
												<div>
													{moment().format('YYYY-MM-DD') === this.state.selectedDay &&
														<b style={{color: 'green', cursor: 'pointer'}}
														   >{obj.resource.last_status}</b>}

												</div>
												<div>
													<sup title="Total Drive Time">
														{!this.props.loadingResources ?
															<>
																{obj.resource.routeTime ? (obj.resource.routeTime + " min route") : "\xa0"}
															</>
															:
															<>
																Loading
															</>
														}
													</sup>
												</div>
											</>}
										</div>)
									}
								}}
								style={{height: "800px", width: '100%'}}
								onEventResize={this.resizeEvent}
								onDragStart={console.log}
								onView={this.props.handleUpdateView}
								defaultView={this.props.defaultView}
								defaultDate={new Date(now())}
								popup={true}
								onSelectEvent={event => this.toggle(event)}
								onSelectSlot={this.handleSelect}
								resources={this.props.resourceMap}
								resourceIdAccessor="resourceId"
								resourceTitleAccessor="resourceTitle"
								formats={formats}
								eventPropGetter={(this.eventStyleGetter)}
								// start time 5:00am
								min={
									new Date(
										today.getFullYear(),
										today.getMonth(),
										today.getDate(),
										5
									)
								}
								// end time 10:00pm
								max={
									new Date(
										today.getFullYear(),
										today.getMonth(),
										today.getDate(),
										22
									)
								}
							/>
						</div>
						{/*This can wait until after the MVP*/}
						{/*{this.state.unassignedEvents.length >0&&
					<div className={"col-md-2"}>
						<h4 className="section-title">Unassigned</h4>
					</div>}*/}
					</div>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'simple'})}>
					{Object.values(this.state.events).filter(event => moment(event.start).format('MM/DD/YY') === moment().format('MM/DD/YY')).length > 0 ? Object.values(this.state.events).filter(event => moment(event.start).format('MM/DD/YY') === moment().format('MM/DD/YY')).map((event) => {
						return (
							<div style={{display: 'flex', justifyContent: 'center', paddingTop: 5}} onClick={() => {this.toggle(event)}}>
								<Parts.Event event={event} forFe={true}/>
							</div>
						)
					}) : <b>There are no events for today.</b>}
				</div>
				<Framework.Elements.UniversalModal
					parent={this}
					id={currentEvent.ticket ? currentEvent.ticket : " "}
					history={this.props.history}
					object={Objects.ScheduleTicket}
					locations={[""]}
					name={currentEvent.title ? currentEvent.title : "Ticket"}
					toggle={this.state.showTicketModal}
					reportClose={this.toggleClose}
					afterSave={this.handleUpdate}
					afterDelete={true}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
					objectProps={{
						toggleModal: this.toggleClose,
						eventID: this.state.currentEvent.id,
						updateData: this.props.updateData
					}}
				/>
				<div>
					<Modal
						isOpen={this.state.showModal}
						toggle={this.toggleClose}
						size={"md"}
						backdrop={true}
					>
						<ModalHeader toggle={this.toggleClose}>
							{currentEvent.id ? currentEvent.title : "Add Event"}
						</ModalHeader>
						<ModalBody>
							<div className={"row"}>
								<div className={"col-6"}>
									<div className={"form-group"}>
										<TextField
											fullWidth={true}
											size={"small"}
											label={"Title"}
											value={this.state.currentEvent.title}
											onChange={(e) =>
												this.setState({currentEvent: {...this.state.currentEvent, title: e.currentTarget.value}})}
											variant="outlined"
											disabled={true}
										/>
									</div>
								</div>
								{!currentEvent.allDay &&
									<div className={"col-6"}>
										<div className={"form-group"}>
											<TextField
												fullWidth={true}
												size={"small"}
												label={"Ticket ID"}
												value={this.state.currentEvent.ticket}
												onChange={(e) =>
													this.setState({currentEvent: {...this.state.currentEvent, ticket: e.currentTarget.value}})}
												variant="outlined"
												disabled={true}
											/>
										</div>
									</div>}
							</div>
							{!currentEvent.allDay &&
								<div className={"row"}>
									<div className={"col-6"}>
										<div className={"form-group"}>
											<TextField
												fullWidth={true}
												size={"small"}
												label={"Start Time"}
												value={this.state.currentEvent.start ? moment(this.state.currentEvent.start).format('MMMM Do YYYY, h:mm:ss a') : null}
												variant="outlined"
												disabled={true}
											/>
										</div>
									</div>
									<div className={"col-6"}>
										<div className={"form-group"}>
											<TextField
												fullWidth={true}
												size={"small"}
												label={"End Time"}
												value={this.state.currentEvent.end ? moment(this.state.currentEvent.end).format('MMMM Do YYYY, h:mm:ss a') : null}
												variant="outlined"
												disabled={true}
											/>
										</div>
									</div>
								</div>}
							<div className={"row"}>
								<div className={"col-12"}>
									<div className={"form-group"}>
										<TextField
											fullWidth={true}
											size={"small"}
											label={"Description"}
											value={this.state.currentEvent.description}
											onChange={(e) =>
												this.setState({currentEvent: {...this.state.currentEvent, description: e.currentTarget.value}})}
											variant="outlined"
											disabled={true}
										/>
									</div>
								</div>
								{currentEvent.actionable && <div className={'col-12'}>
									<FormGroup>
										<FormControlLabel control={
											<Checkbox
												checked={this.state.currentEvent.actioned}
												onChange={async (e) => {
													let model = new API.BuildClass(Types.Calendar._name, API.RequestType.UPDATE);
													this.update = 'POST';
													model.object.pkey = this.state.currentEvent.id;
													model.object.actioned = true;
													await model.submit(null, this.update).then(() => this.props.updateData());

													this.setState({currentEvent: {...this.state.currentEvent, actioned: !this.state.currentEvent.actioned}})
												}}
												color={'primary'}
												disabled={this.state.currentEvent.actioned}
											/>
										} label={"I acknowledge that I have completed this."}/>
									</FormGroup>
								</div>}
								{currentEvent.id &&
									<Button data-id="calendar-log"
									        onClick={this.toggleModalCalendarLog}
									        size="sm"
									        color="grey">
										<i className="fa fa-user"/>&nbsp;&nbsp;Created By {this.state.currentEvent.creatorName} on&nbsp;
										{moment(this.state.currentEvent.created).format('MM/DD/YY')}
										&nbsp;at {moment(this.state.currentEvent.created).format('h:mm a')}
									</Button>
								}
								<Framework.Elements.UniversalModal
									parent={currentEvent.id}
									history={this.props.history}
									object={Collections.CalendarLogModal}
									title={"Change Logs"}
									toggle={this.state.modalCalendarLog}
									reportClose={() => this.toggleCloseCalendarLog()}
									hideGoTo={true}
									hasSubmit={false}
									size={'xl'}
								/>
							</div>
						</ModalBody>
						<ModalFooter>
							{(this.state.ticket !== currentEvent.ticket && currentEvent.allDay !== true) && currentEvent.ticket &&
								<Link to={"/tickets/" + this.state.currentEvent.ticket}>
									<Button color="primary">
										Go to Ticket</Button>
								</Link>
							}
							<Button color="secondary" onClick={this.toggleClose}>Close</Button>
						</ModalFooter>
					</Modal>
				</div>
			</div>
		);
	}
}

